/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import colors from './colors.js';
import fonts from './fonts.js';
import borders from './borders.js';

export default { colors, fonts, borders };
